import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CSidebar, CSidebarBrand, CSidebarNav } from '@coreui/react-pro';

import { systemAdminNav } from '../../_nav';
import { SidebarNav } from '../../components/General/SidebarNav';

import { setSidebarShow } from '../../actions/general';

const SystemAdminSidebar = () => {
     const dispatch = useDispatch();
     const visible = useSelector((state) => state.general.sidebarShow);

     return (
          <CSidebar position="fixed" visible={visible} onVisibleChange={(val) => dispatch(setSidebarShow(val))}>
               <CSidebarBrand className="d-md-down-none" to="/">
                    <span>CAMS-care</span>
               </CSidebarBrand>
               <CSidebarNav>
                    <SidebarNav items={systemAdminNav} />
               </CSidebarNav>
          </CSidebar>
     );
};

export default SystemAdminSidebar;
